import { API } from "./../../../api/config";

export const getRollbackPartnersAPI = (params) => {
    return API.get("/pmbpartner/partners", { params })
              .then((res) => res);
};

export const getRollbackIngestionAPI = (params) => {
    return API.get("/pmbpartner/rollback-ingestion", { params })
              .then((res) => res);
};

export const getRollbackIngestionDetailsAPI = (params) => {
    return API.get("/pmbpartner/rollback-ingestion/details", { params })
              .then((res) => res);
};

export const rollbackAPI = (payload) => {
    return API.post("/pmbpartner/rollback-ingestion/rollback", payload)
              .then((res) => res);
};

export const resetAccountBalanceAPI = (payload) => {
    return API.post("/pmbpartner/rollback-ingestion/reset-account-balance", payload)
              .then((res) => res);
};

export const customerDeletionAPI = (payload) => {
    return API.post("/pmbpartner/rollback-ingestion/customer-deletion", payload)
              .then((res) => res);
};